import { useStore } from 'vuex'
import { ref, computed, onMounted } from 'vue'
import WebshopPaymentSelector from "components/WebshopPaymentSelector/WebshopPaymentSelector.vue"
import { checkoutScrollToTop } from '../CheckoutContent/CheckoutScrollToTop'

export default {
    name: "CheckoutStepThree",
    components: {
        WebshopPaymentSelector 
    },
    props: {
        frivillige: {
            type: Boolean,
            default: false,
            required: false
        }
    },
    setup(props) {
        onMounted(() => checkoutScrollToTop())

        const store = useStore()

        const purchaseData = computed(()=> store.state.checkout.purchaseData )

        const containsUdlaansvare = computed(() => store.state.basket.basketState.containsUdlaansvare)
        const showPickUpAddresses = computed( () => store.state.checkout.stepTwo.showPickUpAddresses)
        const displayUdlaansvarePickupMessage = computed(() => 
            containsUdlaansvare.value && 
            showPickUpAddresses.value && 
            getLabelCheckoutNavigation('udlaanDeliveryText')
        )
        
        const noDeliveryTitle = computed(()=> showPickUpAddresses.value || store.state.checkout.stepTwo.showDifferentAddress ? false : true)
        
        const isSubmitting = computed(()=> store.state.checkout.isSubmitting ?? false)
        
        const unSubmitted = ref(true)
        const hideAllErrors = ref(false)

        const termsInput = ref(false)

        const termsInputFilled = computed(()=> termsInput.value ? termsInput.value : false)

        const paymentData = computed( () => store.state.checkout.stepThree.paymentData)
 
        const paymentDataValidationStatus = computed( () => store.state.checkout.stepThree.paymentData?.paymentMethod) 

        const showPaymentOptions = computed( () => !(store.state.basket?.totals?.isOrderFree ?? false))

        const isSubmissionError = computed(() => store.state.checkout.isSubmissionError ?? false)
        const submissionErrorMessage = computed(() => store.state.checkout.submissionErrorMessage)

        const inputIsValid = function () {
            const paymentMethod = showPaymentOptions.value ? paymentDataValidationStatus.value : true

            return termsInputFilled.value && !!paymentMethod
        }
    
        const handleSendToStep = function (stepNumber) {
            store.commit('checkout/update_checkout_step', { nextStepNumber: stepNumber })
        }

        const onSubmit = function () {
            unSubmitted.value = false

            hideAllErrors.value = true
            setTimeout(()=>{
                // we delay a bit here to allow screenreaders to catchup to changes in the DOM about invalid fields.
                hideAllErrors.value = false
            },100)

            if (!inputIsValid())
                return false

            const checkoutPaymentPayload = {
                paymentData: paymentData.value
            }

            // if terms not accepted do not commit data
            if(!termsInput.value)
                return false

            if (showPaymentOptions.value)
                store.commit('checkout/set_purchase_data_payment', checkoutPaymentPayload )
            
            // if succes set been filled to current step, as data is now in session storage
            store.commit('checkout/update_checkout_step_been_filled', 3)

            // dispatch all mapped purchase data to BE
            if (props.frivillige) {
                store.commit('checkout/set_purchase_data_payment', { paymentData: { paymentMethod: '3'} })
                store.dispatch('checkout/placeOrderFrivillige')
            } else {
                store.dispatch('checkout/placeOrder')
            }
        }

        const getLabel = (labelKey) => store.getters['labels/getLabel']({ labelCollection: 'informationAndDelivery', labelKey, allowEmpty: true })
        const getLabelCheckoutNavigation = (labelKey) => store.getters['labels/getLabel']({ labelCollection: 'checkout', labelKey: labelKey })

        return {
            getLabel,
            getLabelCheckoutNavigation,
            termsInput,
            termsInputFilled,
            onSubmit,
            isSubmitting,
            unSubmitted,
            hideAllErrors,
            purchaseData,
            noDeliveryTitle,
            handleSendToStep,
            noDeliveryTitle,
            toStepTwo: () => store.commit('checkout/update_checkout_step',{nextStepNumber: 2}),
            showPaymentOptions,
            displayUdlaansvarePickupMessage,
            isSubmissionError,
            submissionErrorMessage
        }
    }
}